module.exports = __webpack_public_path__ + "img/pic_subject_geography.d1ff3853.png";